var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHierarchy = function SvgHierarchy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512.001 512.001"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 336h-32v-80c0-8.832-7.168-16-16-16H272v-64h32c8.832 0 16-7.168 16-16V64c0-8.832-7.168-16-16-16h-96c-8.832 0-16 7.168-16 16v96c0 8.832 7.168 16 16 16h32v64H64c-8.832 0-16 7.168-16 16v80H16c-8.832 0-16 7.168-16 16v96c0 8.832 7.168 16 16 16h96c8.832 0 16-7.168 16-16v-96c0-8.832-7.168-16-16-16H80v-64h160v64h-32c-8.832 0-16 7.168-16 16v96c0 8.832 7.168 16 16 16h96c8.832 0 16-7.168 16-16v-96c0-8.832-7.168-16-16-16h-32v-64h160v64h-32c-8.832 0-16 7.168-16 16v96c0 8.832 7.168 16 16 16h96c8.832 0 16-7.168 16-16v-96c0-8.832-7.168-16-16-16"
  })));
};
export default SvgHierarchy;